import React from "react";
import { Button } from "react-bootstrap";
import { PaginationType } from "../Constants/Interfaces";

interface PaginationProps {
  pagination?: PaginationType | null;
  onPageChange: (page: number) => void;
}

/**
 * Shared list pagination. Shows the "Previous" button only when there is a
 * previous page and the "Next" button only when there is a next page, so the
 * controls are never active with nowhere to go.
 */
const Pagination: React.FC<PaginationProps> = ({ pagination, onPageChange }) => {
  if (!pagination) {
    return null;
  }

  const currentPage = pagination.currentPage || 1;
  const totalPages = pagination.totalPages || 0;
  const hasPrev = currentPage > 1;
  // nextPage holds the next page number when one exists; the API returns a
  // falsy value (null/false/0) when there is no next page.
  const nextPage = pagination.nextPage;
  const hasNext = typeof nextPage === "number" && nextPage > currentPage;

  // Nothing to navigate and no page info worth showing.
  if (!hasPrev && !hasNext && totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagging-infos">
      {hasPrev ? (
        <Button onClick={() => onPageChange(currentPage - 1)}>Previous</Button>
      ) : (
        <span className="pagging-spacer" />
      )}

      {totalPages > 0 && (
        <div className="pagging-text">
          Page {currentPage} of {totalPages}
        </div>
      )}

      {hasNext ? (
        <Button onClick={() => onPageChange(pagination.nextPage as number)}>
          Next
        </Button>
      ) : (
        <span className="pagging-spacer" />
      )}
    </div>
  );
};

export default Pagination;
